/**
 * "Pending medical gate" drafts table (Admissions page, second tab).
 */
import React from "react";
import { Button } from "@/components/ui/button";
import { CloudArrowUp, CheckCircle, PencilSimple } from "@phosphor-icons/react";

export function DraftsTable({ drafts, onEdit, onUploadMedical }) {
  return (
    <div className="vs-card overflow-x-auto mt-4">
      <table className="w-full text-sm">
        <thead className="bg-[var(--vs-bg-subtle)]">
          <tr className="text-left text-[11px] uppercase font-mono tracking-widest text-[var(--vs-text-secondary)]">
            <th className="px-4 py-3">VS-ID</th>
            <th className="px-4 py-3">Name</th>
            <th className="px-4 py-3">DOB</th>
            <th className="px-4 py-3">Allocation</th>
            <th className="px-4 py-3">Action</th>
          </tr>
        </thead>
        <tbody>
          {drafts.map((d) => (
            <tr key={d.id} className="border-t border-[var(--vs-border)]">
              <td className="px-4 py-3 font-mono text-xs">{d.vs_id}</td>
              <td className="px-4 py-3 font-medium">{d.name}</td>
              <td className="px-4 py-3">{d.dob}</td>
              <td className="px-4 py-3 text-xs">{d.class_name || "—"} • R{d.room_no}/B{d.bed_no}</td>
              <td className="px-4 py-3 flex items-center gap-2">
                <Button size="sm" variant="outline" data-testid={`edit-draft-${d.vs_id}`} onClick={() => onEdit(d)}>
                  <PencilSimple size={12} className="mr-1.5" /> Update
                </Button>
                <label className="text-xs px-3 py-1.5 rounded-md bg-[var(--vs-secondary)] text-[var(--vs-bg)] hover:bg-[var(--vs-secondary-hover)] cursor-pointer inline-flex items-center gap-1.5">
                  <CloudArrowUp size={12} /> Medical
                  <input data-testid={`medical-input-${d.vs_id}`} type="file" accept="application/pdf,image/jpeg,image/png" className="hidden" onChange={(e) => onUploadMedical(d.id, e.target.files?.[0])} />
                </label>
              </td>
            </tr>
          ))}
          {drafts.length === 0 && (
            <tr>
              <td colSpan={5} className="px-4 py-10 text-center text-[var(--vs-text-secondary)]">
                <CheckCircle size={20} className="text-[var(--vs-success)] inline mr-2" />
                No drafts pending — every admission has a medical certificate.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
